import React, { useState } from 'react';
import { api } from '../utils/api';

const icons = {
  newspaper: 'M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z',
  briefcase: 'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
  chart: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
  layout: 'M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z',
  search: 'M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z',
  wallet: 'M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z',
  tool: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z',
};

export default function ToolCard({ tool, health }) {
  const [loading, setLoading] = useState(false);

  const statusColor = health === 'online' ? '#22c55e' : health === 'offline' ? '#ef4444' : '#d1d5db';
  const iconPath = icons[tool.icon] || icons.tool;

  const handleClick = async () => {
    if (loading) return;
    // If the tool doesn't use SSO, open it directly — no token needed
    if (!tool.sso_enabled) {
      window.open(tool.url, '_blank');
      return;
    }
    setLoading(true);
    try {
      const result = await api.post('/auth/sso/generate', { toolId: tool.id });
      window.open(result.redirectUrl, '_blank');
    } catch (err) {
      // Fallback: open tool URL directly
      window.open(tool.url, '_blank');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading}
      className="w-full bg-white rounded-xl p-5 shadow-sm hover:shadow-md transition-all text-left group border border-gray-100"
      style={{ borderLeftWidth: '3px', borderLeftColor: statusColor }}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="w-10 h-10 rounded-lg flex items-center justify-center transition-colors"
          style={{ backgroundColor: 'rgba(15,17,23,0.04)' }}>
          <svg className="w-5 h-5 transition-colors" style={{ color: '#0f1117' }} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d={iconPath} />
          </svg>
        </div>
        <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: statusColor }} title={health || 'desconocido'} />
      </div>
      <h3 className="font-semibold text-gray-900 mb-1">{tool.name}</h3>
      <p className="text-sm text-gray-500 mb-3 line-clamp-2">{tool.description}</p>
      {tool.category && (
        <span className="inline-block text-xs px-2 py-0.5 rounded-full" style={{ backgroundColor: '#f1f3f5', color: '#6b7280' }}>{tool.category}</span>
      )}
    </button>
  );
}
